export var DEPLOY_DATE = new Date('2026-09-01T14:03:57+0000');
